import { Input } from "./ui/input";

// Quick presets a reviewer taps instead of typing out the same handful of
// reasons over and over — clicking one just fills the text field below, which
// stays fully editable, so "custom text" is simply typing over/past a preset
// rather than a separate input mode.
const PRESETS = [
  "Blurry / Unreadable Scan",
  "Incomplete Pages",
  "Wrong Document Type",
];

function slug(s) {
  return s.toLowerCase().replace(/[^a-z]+/g, "-").replace(/(^-|-$)/g, "");
}

/**
 * Shared rejection-reason input for the Document Workbench (Applications.jsx)
 * and DocumentPreviewModal's fast-action footer — preset chips + a free-text
 * fallback, both writing into the same `value`/`onChange`.
 */
export default function RejectReasonPicker({ value, onChange, testIdPrefix = "reject-reason" }) {
  return (
    <div className="space-y-2" data-testid={`${testIdPrefix}-picker`}>
      <div className="flex flex-wrap gap-1.5">
        {PRESETS.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            data-testid={`${testIdPrefix}-preset-${slug(p)}`}
            className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${
              value === p
                ? "bg-red-600 text-white border-red-600"
                : "bg-white text-slate-600 border-slate-200 hover:border-red-300 hover:text-red-600"
            }`}
          >
            {p}
          </button>
        ))}
      </div>
      <Input
        autoFocus
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Reason for rejection (required) — pick a preset above or type your own"
        className="h-9 text-sm"
        data-testid={`${testIdPrefix}-input`}
      />
    </div>
  );
}
